var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MainLayout",
    {
      staticClass: "hide-header-menu landing-main-v3",
      attrs: { "attach-home": _vm.attachHome, "hide-app-header": true }
    },
    [
      _c(
        "div",
        {
          staticClass: "landing-main-v3__container",
          attrs: { slot: "layout-body" },
          slot: "layout-body"
        },
        [
          _c("div", { staticClass: "landing-block-1" }, [
            _c("div", { staticClass: "landing-block-1__logo" }, [
              _c("img", {
                attrs: { src: "/static/images/ic-classting-logo.svg" }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "landing-block-1__title text-center" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("landing_v3.block1.title")) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "landing-block-1__subtitle text-center hidden-sm-down"
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("landing_v3.block1.subtitle")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "landing-block-1__subtitle text-center hidden-md-up",
              domProps: {
                innerHTML: _vm._s(_vm.$t("landing_v3.block1.subtitle_mobile"))
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "landing-block-1__btn-row mx-auto" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-md-6" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-block btn-rectangle",
                      on: {
                        click: function($event) {
                          return _vm.startCl()
                        }
                      }
                    },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("landing_v3.block1.start_btn")
                          )
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-6" }, [
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-outline-primary btn-block btn-rectangle",
                      attrs: { href: _vm.aiUrl, target: "_blank" }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("landing_v3.block1.go_to_premium")) +
                          "\n            "
                      )
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "landing-block-1__partner-list mx-auto" },
              [
                _c("img", {
                  attrs: { src: "/static/images/img-cp-list-small@2x.png" }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "landing-block-2" }, [
            _c("div", {
              staticClass:
                "landing-block-2__title text-center typography--color-primary",
              domProps: { innerHTML: _vm._s(_vm.$t("landing_v3.block2.title")) }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "landing-block-2__main-intro mx-auto" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col align-self-center text-center hidden-sm-down"
                  },
                  [
                    _c("img", {
                      staticClass:
                        "align-self-center landing-block-2__main-before",
                      attrs: { src: "/static/images/img-main-before.svg" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("img", {
                  staticClass: "align-self-center landing-block-2__bg-arrow",
                  attrs: { src: "/static/images/img-main-arrow-line.png" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-md-7 landing-block-2__main-video text-center"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "landing-block-2__main-video__student-icon"
                      },
                      [
                        _c("img", {
                          attrs: { src: "/static/images/ic-student-m.svg" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("video", { attrs: { autoplay: "", loop: "" } }, [
                      _c("track", { attrs: { kind: "captions" } }),
                      _vm._v(" "),
                      _c("source", {
                        attrs: {
                          src: "/static/videos/main_intro_v3.mp4",
                          type: "video/mp4"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col align-self-center text-center hidden-sm-down"
                  },
                  [
                    _c("img", {
                      staticClass: "landing-block-2__main-after",
                      attrs: { src: "/static/images/img-main-after.svg" }
                    })
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "landing-block-3" }, [
            _c(
              "div",
              { staticClass: "landing-block-3__guide-arrow text-center" },
              [
                _c("img", {
                  attrs: { src: "/static/images/ic-arrow-intro.svg" }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "landing-block-3__title text-center typography--color-primary"
              },
              [
                _c("img", {
                  attrs: {
                    src: "/static/images/img-cl-logo-intro.svg",
                    alt: "Classting Learning"
                  }
                }),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("landing_v3.block3.title")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "landing-block-3__guide-number text-center" },
              [_vm._v("\n        01\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "landing-block-3__feature-intro mx-auto" },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-5 push-md-7 landing-block-3__feature-intro__text"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "landing-block-3__feature-intro__title typography--color-primary"
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("landing_v3.block3.features.01.title")
                              ) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "landing-block-3__feature-intro__description typography--color-secondary",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("landing_v3.block3.features.01.description")
                          )
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-7 pull-md-5 landing-block-3__feature-intro__video"
                    },
                    [
                      _c("video", { attrs: { autoplay: "", loop: "" } }, [
                        _c("track", { attrs: { kind: "captions" } }),
                        _vm._v(" "),
                        _c("source", {
                          attrs: {
                            src: "/static/videos/assign_easily_v3.mp4",
                            type: "video/mp4"
                          }
                        })
                      ])
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "landing-block-3__guide-number text-center" },
              [_vm._v("\n        02\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "landing-block-3__feature-intro mx-auto" },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-5 landing-block-3__feature-intro__text"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "landing-block-3__feature-intro__text-right"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "landing-block-3__feature-intro__title typography--color-primary"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "landing_v3.block3.features.02.title"
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "landing-block-3__feature-intro__description typography--color-secondary",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "landing_v3.block3.features.02.description"
                                )
                              )
                            }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-7 landing-block-3__feature-intro__video"
                    },
                    [
                      _c("video", { attrs: { autoplay: "", loop: "" } }, [
                        _c("track", { attrs: { kind: "captions" } }),
                        _vm._v(" "),
                        _c("source", {
                          attrs: {
                            src: "/static/videos/learning_reports_v3.mp4",
                            type: "video/mp4"
                          }
                        })
                      ])
                    ]
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "landing-block-5" },
            [
              _c(
                "carousel",
                {
                  attrs: {
                    "per-page": 1,
                    "pagination-active-color": "#00c896",
                    "pagination-color": "rgba(0, 0, 0, 0.1)",
                    "pagination-padding": 6,
                    "pagination-size": 10,
                    loop: true,
                    "autoplay-hover-pause": true,
                    "autoplay-timeout": 3000,
                    autoplay: false
                  }
                },
                _vm._l(_vm.selectedAnalysisSlides, function(item) {
                  return _c("slide", { key: item.id }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 col-md-6 landing-block-5__slide-image"
                        },
                        [
                          _c("img", {
                            staticClass: "img-fluid",
                            attrs: { src: item.image }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 col-md-6 align-self-center landing-block-5__slide-text"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "landing-block-5__title typography--color-primary typography--font-weight-500"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t(item.title)) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "landing-block-5__description typography--color-secondary",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t(item.subtitle))
                            }
                          })
                        ]
                      )
                    ])
                  ])
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "landing-block-6" }, [
            _c(
              "div",
              {
                staticClass:
                  "landing-block-6__title typography--color-primary text-center"
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("landing_v3.block6.title")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "landing-block-6__subtitle typography--color-secondary text-center mx-auto",
              domProps: {
                innerHTML: _vm._s(_vm.$t("landing_v3.block6.subtitle"))
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "landing-block-6__stats mx-auto" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-md-4 text-center" }, [
                  _c("div", { staticClass: "landing-block-6__stats__icon" }, [
                    _c("img", {
                      attrs: { src: "/static/images/ic-total-user.svg" }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "landing-block-6__stats__number" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("landing_v3.block6.stats.users.count")) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "landing-block-6__stats__label typography--color-secondary typography--font-weight-500"
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t("landing_v3.block6.stats.users.label")
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-4 text-center" }, [
                  _c("div", { staticClass: "landing-block-6__stats__icon" }, [
                    _c("img", {
                      attrs: { src: "/static/images/ic-total-teacher.svg" }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "landing-block-6__stats__number" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t("landing_v3.block6.stats.teachers.count")
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "landing-block-6__stats__label typography--color-secondary typography--font-weight-500"
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t("landing_v3.block6.stats.teachers.label")
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-4 text-center" }, [
                  _c("div", { staticClass: "landing-block-6__stats__icon" }, [
                    _c("img", {
                      attrs: { src: "/static/images/ic-total-school.svg" }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "landing-block-6__stats__number" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t("landing_v3.block6.stats.schools.count")
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "landing-block-6__stats__label typography--color-secondary typography--font-weight-500"
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t("landing_v3.block6.stats.schools.label")
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "landing-block-7" }, [
            _c("div", { staticClass: "landing-block-7__title text-center" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("landing_v3.block7.title")) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "landing-block-7__subtitle text-center mx-auto" },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("landing_v3.block7.subtitle")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "landing-block-7__btn-row mx-auto" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-md-6" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-block btn-rectangle",
                      on: {
                        click: function($event) {
                          return _vm.startCl()
                        }
                      }
                    },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("landing_v3.block7.start_btn")
                          )
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6" },
                  [
                    _c("router-link", {
                      staticClass:
                        "btn btn-outline-primary btn-block btn-rectangle",
                      attrs: { to: "/inquiries", tag: "button" },
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("landing_v3.block7.inquiry_btn")
                        )
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "landing-block-8" }, [
            _c(
              "div",
              { staticClass: "landing-block-8__testimonials hidden-sm-down" },
              [
                _c("div", { staticClass: "row no-gutters teachers-top-row" }, [
                  _c("div", { staticClass: "col teachers-side-col" }, [
                    _c("div", { staticClass: "row no-gutters" }, [
                      _c(
                        "div",
                        { staticClass: "col col-md-6 teachers-img-col" },
                        [
                          _c("div", [
                            _c("div", { staticClass: "transparent-bg" }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "w-100 img-fluid",
                              attrs: { src: "/static/images/left-1-1.jpg" }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("div", { staticClass: "transparent-bg" }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "w-100 img-fluid",
                              attrs: { src: "/static/images/left-2-1.jpg" }
                            })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col col-md-6 teachers-img-col" },
                        [
                          _c("div", [
                            _c("div", { staticClass: "transparent-bg" }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "w-100 img-fluid",
                              attrs: { src: "/static/images/left-1-2.jpg" }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("div", { staticClass: "transparent-bg" }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "w-100 img-fluid",
                              attrs: { src: "/static/images/left-2-2.jpg" }
                            })
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col teachers-middle-col" }, [
                    _c("div", { staticClass: "landing-block-8__video-cover" }, [
                      _c("div", {
                        staticClass:
                          "landing-block-8__video-cover__title text-center",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("landing_v3.block8.video_title")
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-center" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "landing-block-8__video-cover__btn clickable",
                            on: {
                              click: function($event) {
                                _vm.showVideo = true
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/static/images/ic-play-btn.svg",
                                alt: "play teacher interview video"
                              }
                            })
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.showVideo
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "landing-block-8__close-video-btn clickable",
                            on: {
                              click: function($event) {
                                _vm.showVideo = false
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: { src: "/static/images/icon-cancel.svg" }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showVideo
                      ? _c(
                          "div",
                          { staticClass: "landing-block-8__video-container" },
                          [
                            _c("iframe", {
                              attrs: {
                                frameborder: "0",
                                width: "560",
                                height: "315",
                                id: "video",
                                src:
                                  "https://www.youtube.com/embed/FJNviT9gJss?autoplay=1;rel=0&showinfo=0",
                                allowfullscreen: ""
                              }
                            })
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col teachers-side-col" }, [
                    _c("div", { staticClass: "row no-gutters" }, [
                      _c(
                        "div",
                        { staticClass: "col col-md-6 teachers-img-col" },
                        [
                          _c("div", [
                            _c("div", { staticClass: "transparent-bg" }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "w-100 img-fluid",
                              attrs: { src: "/static/images/right-1-1.jpg" }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("div", { staticClass: "transparent-bg" }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "w-100 img-fluid",
                              attrs: { src: "/static/images/right-2-1.jpg" }
                            })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col col-md-6 teachers-img-col" },
                        [
                          _c("div", [
                            _c("div", { staticClass: "transparent-bg" }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "w-100 img-fluid",
                              attrs: { src: "/static/images/right-1-2.jpg" }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("div", { staticClass: "transparent-bg" }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "w-100 img-fluid",
                              attrs: { src: "/static/images/right-2-2.jpg" }
                            })
                          ])
                        ]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row no-gutters teachers-bottom-row" },
                  [
                    _c("div", { staticClass: "col teachers-img-col" }, [
                      _c("div", { staticClass: "transparent-bg" }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "w-100 img-fluid",
                        attrs: { src: "/static/images/bottom-1-1.jpg" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col teachers-img-col" }, [
                      _c("div", { staticClass: "transparent-bg" }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "w-100 img-fluid",
                        attrs: { src: "/static/images/bottom-1-2.jpg" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col teachers-img-col" }, [
                      _c("div", { staticClass: "transparent-bg" }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "w-100 img-fluid",
                        attrs: { src: "/static/images/bottom-1-3.jpg" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col teachers-img-col" }, [
                      _c("div", { staticClass: "transparent-bg" }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "w-100 img-fluid",
                        attrs: { src: "/static/images/bottom-1-4.jpg" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col teachers-img-col" }, [
                      _c("div", { staticClass: "transparent-bg" }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "w-100 img-fluid",
                        attrs: { src: "/static/images/bottom-1-5.jpg" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col teachers-img-col" }, [
                      _c("div", { staticClass: "transparent-bg" }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "w-100 img-fluid",
                        attrs: { src: "/static/images/bottom-1-6.jpg" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col teachers-img-col" }, [
                      _c("div", { staticClass: "transparent-bg" }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "w-100 img-fluid",
                        attrs: { src: "/static/images/bottom-1-7.jpg" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col teachers-img-col" }, [
                      _c("div", { staticClass: "transparent-bg" }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "w-100 img-fluid",
                        attrs: { src: "/static/images/bottom-1-8.jpg" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col teachers-img-col" }, [
                      _c("div", { staticClass: "transparent-bg" }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "w-100 img-fluid",
                        attrs: { src: "/static/images/bottom-1-9.jpg" }
                      })
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "landing-block-8__testimonials-mobile hidden-md-up"
              },
              [
                _c("div", { staticClass: "landing-block-8__video-cover" }, [
                  _c("div", {
                    staticClass:
                      "landing-block-8__video-cover__title text-center",
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("landing_v3.block8.video_title"))
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-center" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "landing-block-8__video-cover__btn clickable",
                        on: {
                          click: function($event) {
                            _vm.showVideo = true
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/static/images/ic-play-btn.svg",
                            alt: "play teacher interview video"
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.showVideo
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "landing-block-8__close-video-btn clickable",
                        on: {
                          click: function($event) {
                            _vm.showVideo = false
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: { src: "/static/images/icon-cancel.svg" }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showVideo
                  ? _c(
                      "div",
                      { staticClass: "landing-block-8__video-container" },
                      [
                        _c("iframe", {
                          attrs: {
                            frameborder: "0",
                            width: "560",
                            height: "315",
                            id: "video-mobile",
                            src:
                              "https://www.youtube.com/embed/FJNviT9gJss?autoplay=1;rel=0&showinfo=0",
                            allowfullscreen: ""
                          }
                        })
                      ]
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "landing-block-8__edulab-photos-mobile hidden-md-up"
              },
              [
                _c("img", {
                  staticClass: "w-100",
                  attrs: { src: "/static/images/bg-edulab-768.jpg" }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "landing-block-9" }, [
            _c("div", { staticClass: "text-center" }, [_c("FooterContent")], 1)
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d58196e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d58196e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingMainV3.vue
// module id = Yskx
// module chunks = 1